import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import "./NavBar.css";
import config from "../config";
import NavDrawer from "./NavDrawer/NavDrawer";
import ProductDrawer from "./Products/ProductDropdown";
import AboutDrawer from "./Home/AboutDropdown";
import ServiceDrawer from "./Services/ServiceDropdown";
import { ChevronDown } from "lucide-react";
import { useSelector } from "react-redux";


const services = [
  { title: "Market Research Services" },
  { title: "Product Drawing Consultancy" },
  { title: "Supply Chain Management Consultancy" },
  { title: "Software Development Consultancy" },
  { title: "Transportation Logistics Consultancy Service" },
  { title: "Accounting and Financial Management" },
];



const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [productDrawerOpen, setProductDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [serviceDrawerOpen, setServiceDrawerOpen] = useState(false);
  const { products } = useSelector((state) => state.data);
  const [aboutDrawerOpen, setAboutDrawerOpen] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setActiveSection("home");
    } else if (path.startsWith("/about-us-section")) {
      setActiveSection("about");
    } else if (path.startsWith("/career") || path.startsWith("/job-description")) {
      setActiveSection("career");
    } else if (path === "/services" || path.startsWith("/service-description")) {
      setActiveSection("services");
    } else if (
      path === "/products-section" ||
      path.startsWith("/product-page") ||
      path.startsWith("/Products/")
    ) {
      setActiveSection("products");
    } else if (path === "/contact-us") {
      setActiveSection("contactus");
    } else if (path === "/quality-section") {
      setActiveSection("quality");
    } else if (path.startsWith("/gallery")) {
      setActiveSection("gallery");
    } else {
      setActiveSection("");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname !== "/" && !location.pathname.startsWith("/about-us-section")) {
        return;
      }

      const missionSection = document.getElementById("who-we-are-section");
      const valuesSection = document.getElementById("what-we-do-section");
      const visionSection = document.getElementById("vision-mission-value-section");

      if (missionSection && missionSection.getBoundingClientRect().top < window.innerHeight * 0.5) {
        setActiveSection("about");
      } else if (valuesSection && valuesSection.getBoundingClientRect().top < window.innerHeight * 0.5) {
        setActiveSection("about");
      } else if (visionSection && visionSection.getBoundingClientRect().top < window.innerHeight * 0.5) {
        setActiveSection("about");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname !== "/") {
        return;
      }

      const productSection = document.getElementById("products-section");
      const productHeader = document.querySelector(".product-experience-section");

      if (productSection || productHeader) {
        const sectionTop = productSection ? productSection.getBoundingClientRect().top : Infinity;
        const headerTop = productHeader ? productHeader.getBoundingClientRect().top : Infinity;

        if (sectionTop < window.innerHeight * 0.5 || headerTop < window.innerHeight * 0.5) {
          setActiveSection("products");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);





  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);




  return (
    <>
      <nav className={scrolled ? "scrolled" : ""}>
        <div className="nav2">
          {isMobile && (<div className={`menu-icon ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          )}
          <div
            className="main-logo"
            onClick={() => {
              if (location.pathname === "/") {
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                navigate("/");
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }, 500);
              }
            }}
          >
            <img src={config.logo} alt="Company Logo" style={{ height: "50px" }} />

          </div>

          {/* Show menu icon only on mobile */}
          {!isMobile && (

            <div className="finalmenu">
              <ul className="navcenter">
              <li
  className={activeSection === "home" ? "active" : ""}
  onClick={() => {
    navigate("/");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
  }}
>
  HOME
</li>
<li
  className={`dropdown ${activeSection === "about" ? "active" : ""}
  ${aboutDrawerOpen && activeSection !== "about" ? "glow" : ""}`}
  onClick={() => {
    setAboutDrawerOpen(!aboutDrawerOpen);
    setProductDrawerOpen(false);
    setServiceDrawerOpen(false);
  }}
>
  <div className="dropdown-toggle">
    ABOUT US
    <motion.span
      className="dropdown-icon"
      animate={{ rotate: aboutDrawerOpen ? 180 : 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <ChevronDown size={18} />
    </motion.span>
    <AboutDrawer
      isOpen={aboutDrawerOpen}
      onClose={() => setAboutDrawerOpen(false)}
    />
  </div>
</li>



                {/* Products Dropdown */}
                <li
  className={`dropdown ${(activeSection === "products" || activeSection === "product-page") ? "active" : ""}
  ${productDrawerOpen || location.pathname.startsWith("/Products/") ? "glow" : ""}`}
  onClick={() => {
    setProductDrawerOpen(!productDrawerOpen);
    setAboutDrawerOpen(false);
    setServiceDrawerOpen(false);
  }}
>
                  <div className="dropdown-toggle">
                    PRODUCTS
                    <motion.span
                      className="dropdown-icon"
                      animate={{ rotate: productDrawerOpen ? 180 : 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                      <ChevronDown size={18} />
                    </motion.span>
                    <ProductDrawer
                      isOpen={productDrawerOpen}
                      onClose={() => setProductDrawerOpen(false)}
                      products={products}
                    />
                  </div>
                </li>

                {/* Career Link */}


                {/* Services Dropdown */}
                <li
                  className={`dropdown ${activeSection === "services" ? "active" : ""}
                  ${serviceDrawerOpen && activeSection !== "services" ? "glow" : ""}`}
                  onClick={() => {
                    setServiceDrawerOpen(!serviceDrawerOpen);
                    setAboutDrawerOpen(false);
                    setProductDrawerOpen(false);
                  }}
                >
                  <div className="dropdown-toggle">
                    SERVICES
                    <motion.span
                      className="dropdown-icon"
                      animate={{ rotate: serviceDrawerOpen ? 180 : 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                      <ChevronDown size={18} />
                    </motion.span>
                    <ServiceDrawer
                    isOpen={serviceDrawerOpen}
                    onClose={() => setServiceDrawerOpen(false)}
                    services={services}
                    />
                  </div>
                </li>

                <li className={activeSection === "career" ? "active" : ""} onClick={() => navigate("/career")}>
                  CAREER
                </li>

                <li
                  className={activeSection === "gallery" ? "active" : ""}
                  onClick={() => navigate("/gallery")}
                >
                  GALLERY
                </li>

                <li className={activeSection === "contactus" ? "active" : ""} onClick={() => navigate("/contact-us")}>
                  CONTACT US
                </li>
              </ul>
            </div>
          )}
          <div className="contact-info">
            <div className="vertical-line"></div>
            <div className="right-section">
              {/* <div className="contact-box2">
          <img src={mailIcon} alt="Mail" className="contact-icon" style={{ height: "39px" }} />
            <div>
              <div className="contact-number2">
                <a href="mailto:sales@akinex.com" className="contact-text">
                    sales@akinex.com
                    </a>
                    </div>
                     <div className="call-us2">
                    <a href="mailto:sales@akinex.com" className="contact-text2">Mail us now!</a>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>


        {/* <ServiceDrawer
          isOpen={serviceDrawerOpen}
          onClose={() => setServiceDrawerOpen(false)}
          services={services}
        /> */}
      </nav>

      {/* Render NavDrawer only for mobile devices using React Portal */}
      {isMobile &&
        ReactDOM.createPortal(
          <NavDrawer
            isOpen={menuOpen}
            onClose={() => setMenuOpen(false)}
            products={products}
            services={services}
          />,
          document.body
        )}
    </>
  );
};

export default NavBar;